import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type OtpResponse = {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  refresh_token_expires_in: number;
  otp_response: {
    bankCardToken: string;
    authCode: string;
    originalPartnerReferenceNo: string;
    originalReferenceNo: string;
    responseCode: string;
    responseMessage: string;
  };
};

interface BindCardState {
  otpData: OtpResponse | null;
  setOtpData: (data: OtpResponse) => void;
  clearOtpData: () => void;
}

export const useBindCardStore = create<BindCardState>()(
  persist(
    (set) => ({
      otpData: null,
      setOtpData: (data) => set({ otpData: data }),
      clearOtpData: () => set({ otpData: null }),
    }),
    {
      name: 'bind-card-otp',
    }
  )
);
